import { render, staticRenderFns } from "./checkbox-control.vue?vue&type=template&id=bb97331a&"
import script from "./checkbox-control.vue?vue&type=script&lang=js&"
export * from "./checkbox-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bb97331a', component.options)
    } else {
      api.reload('bb97331a', component.options)
    }
    module.hot.accept("./checkbox-control.vue?vue&type=template&id=bb97331a&", function () {
      api.rerender('bb97331a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/ui/checkbox-control.vue"
export default component.exports